import React, { useEffect, useState } from 'react';
import SurveySettings from './smallcomponents/SurveySettings';
import { useSurveyStore, QUESTION_TYPES } from '../surveyutilities/surveyStore';
import TextBlockProperties from './blockproperties/TextBlockProperties';
import MultipleChoiceBlockProperties from './blockproperties/MultipleChoiceBlockProperties.jsx';
import SingleChoiceBlockProperties from './blockproperties/SingleChoiceBlockProperties.jsx';
import RatingBlockProperties from './blockproperties/RatingBlockProperties.jsx';
import TextAreaBlockProperties from './blockproperties/TextAreaBlockProperties.jsx';
import FileUploadBlockProperties from './blockproperties/FileUploadBlockProperties.jsx';
import DropdownBlockProperties from './blockproperties/DropdownBlockProperties.jsx';

function EcxSurveyProperties() {
    const [tabValue, setTabValue] = useState(0);
    const selectedQuestion = useSurveyStore(
        (state) => state.questions.find((q) => q.internalId === state.selectedQuestionId) || null
    );

    useEffect(() => {
        setTabValue(selectedQuestion ? 1 : 0);
    }, [selectedQuestion]);

    const renderProperties = () => {
        if (!selectedQuestion) {
            return (
                <div className="ecx-survey-editor__hint">
                    No question selected. Select a question on the canvas to edit its properties.
                </div>
            );
        }

        switch (selectedQuestion.type) {
            case QUESTION_TYPES.TEXT:
                return <TextBlockProperties questionId={selectedQuestion.internalId} />;
            case QUESTION_TYPES.TEXTAREA:
                return <TextAreaBlockProperties questionId={selectedQuestion.internalId} />;
            case QUESTION_TYPES.SINGLE_CHOICE:
                return <SingleChoiceBlockProperties questionId={selectedQuestion.internalId} />;
            case QUESTION_TYPES.MULTIPLE_CHOICE:
                return <MultipleChoiceBlockProperties questionId={selectedQuestion.internalId} />;
            case QUESTION_TYPES.DROPDOWN:
                return <DropdownBlockProperties questionId={selectedQuestion.internalId} />;
            case QUESTION_TYPES.RATING:
                return <RatingBlockProperties questionId={selectedQuestion.internalId} />;
            case QUESTION_TYPES.FILE_UPLOAD:
                return <FileUploadBlockProperties questionId={selectedQuestion.internalId} />;
            default:
                return (
                    <div className="ecx-survey-editor__hint">
                        Properties for {selectedQuestion.type} are not implemented yet.
                    </div>
                );
        }
    };

    return (
        <>
            <div className="ecx-survey-editor__properties-tabs" role="tablist">
                <button
                    type="button"
                    role="tab"
                    className={`ecx-survey-editor__tab${tabValue === 0 ? ' is-active' : ''}`}
                    aria-selected={tabValue === 0}
                    onClick={() => setTabValue(0)}
                >
                    Survey settings
                </button>
                <button
                    type="button"
                    role="tab"
                    className={`ecx-survey-editor__tab${tabValue === 1 ? ' is-active' : ''}`}
                    aria-selected={tabValue === 1}
                    onClick={() => setTabValue(1)}
                >
                    Selected question
                </button>
            </div>

            <div className="ecx-survey-editor__properties-body">
                {tabValue === 0 ? <SurveySettings /> : renderProperties()}
            </div>
        </>
    );
}

export default EcxSurveyProperties;
